export default [
  {
    section: 'Pilotage',
    items: [
      { title: 'Tableau de bord', icon: 'mdi-view-dashboard-outline', route: 'dashboard' },
      { title: 'Statistiques', icon: 'mdi-chart-line', route: 'stats' },
      { title: 'Signatures Yousign', icon: 'mdi-signature-freehand', route: 'yousign' }
    ]
  },
  {
    section: 'Clients',
    items: [
      { title: 'Comptes', icon: 'mdi-briefcase-outline', route: 'accounts' },
      { title: 'Utilisateurs', icon: 'mdi-account-multiple-outline', route: 'users' },
      { title: 'Clés d\'API', icon: 'mdi-key-outline', route: 'apikeys' }
    ]
  },
  {
    section: 'Catalogue',
    items: [
      { title: 'Programmes', icon: 'mdi-office-building', route: 'programs' },
      { title: 'Lots', icon: 'mdi-home-outline', route: 'lots' },
      { title: 'Ventes', icon: 'mdi-file-document-edit-outline', route: 'reservations' }
    ]
  },
  {
    section: 'Facturation',
    items: [
      { title: 'Abonnements', icon: 'mdi-credit-card-outline', route: 'plans' },
      { title: 'Articles', icon: 'mdi-tag-outline', route: 'billsItems' },
      { title: 'Consommations', icon: 'mdi-counter', route: 'billsRow' },
      { title: 'Factures', icon: 'mdi-receipt', route: 'billsList' }
    ]
  },
  {
    section: 'Plateforme',
    items: [
      { title: 'Bandeau d\'annonce', icon: 'mdi-bullhorn-outline', route: 'banner' },
      { title: 'Copie prod → pré-prod', icon: 'mdi-database-refresh', route: 'preprodRefresh' }
    ]
  }
]

export const OTHER_TITLES = {
  accountVue: 'Fiche compte',
  newAccount: 'Nouveau compte',
  newDiscount: 'Nouvelle remise',
  newPlan: 'Abonnement',
  newBillsItem: 'Nouvel article',
  editBillsItem: 'Modifier l\'article',
  Mgc: 'MGC'
}

export function routeTitle (sections, name) {
  for (const group of sections) {
    const item = group.items.find(i => i.route === name)
    if (item) return { title: item.title, section: group.section }
  }
  return { title: OTHER_TITLES[name] || '', section: null }
}
